"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamSlice = streamSlice;
const streamInitialState = () => {
    const initialAfter = Date.now();
    const initialData = { events: [], lastTimestamp: initialAfter };
    return {
        stream: {
            initialAfter,
            streamData: initialData,
            currentStreamData: initialData,
        },
    };
};
function streamSlice(set) {
    return {
        ...streamInitialState(),
        setStreamData: (newData) => {
            set(state => {
                state.stream.streamData.events = newData.events;
                state.stream.streamData.lastTimestamp = newData.lastTimestamp || state.stream.initialAfter;
                return state;
            }, false, '[streamApi] setStreamData');
        },
        setCurrentStreamData: (newData) => {
            set(state => {
                state.stream.currentStreamData = newData;
                return state;
            }, false, '[streamApi] setCurrentStreamData');
        },
    };
}
